import api from "@/libs/axios";
import authHelpers from "@/utils/auth-helpers";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    user: {},
    loading: false,
    updateLoading: false,
  },
  getters: {
    user(state) {
      return state.user;
    },
    updateLoading(state) {
      return state.updateLoading;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    async getUserInfo(context) {
      const endpoint = authHelpers.isUserMinistry()
        ? ep.MINISTRY_USER
        : ep.USER;
      context.state.loading = true;
      await api.get(endpoint).then((res) => {
        context.commit("setUser", res.data.data);
        context.state.loading = false;
      });
    },

    async updateUser(context, payload) {
      const endpoint = authHelpers.isUserMinistry()
        ? ep.MINISTRY_USER
        : ep.USER;
      context.state.updateLoading = true;
      await api.put(endpoint, payload).then((res) => {
        context.dispatch("handleResponse", res);
        context.state.updateLoading = false;
        context.dispatch("getUserInfo");
      });
    },

    async changePassword(context, payload) {
      const endpoint = authHelpers.isUserMinistry()
        ? ep.MINISTR_CHANGE_PASSWORD
        : ep.CHANGE_PASSWORD;
      context.state.loading = true;
      await api.post(endpoint, payload).then((res) => {
        context.dispatch("handleResponse", res);
        context.state.loading = false;
      });
    },
    handleResponse({ commit, dispatch }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
